import axios from 'axios'

export default {
  /**
   * Retrieve all deliveries
   */
  list: async function (query = null) {
    return axios.get('api/v1/delivery' + (query ? '?' + query : ''))
  },

  /**
   * Create a delivery
   * @param {Object} postData - additional data to include in the request
   */
  create: async function (postData = {}) {
    return axios.post('api/v1/delivery', postData)
  },

  /**
   * Get a delivery by id
   * @param {String} deliveryID - the delivery id
   */
  getByID: async function (deliveryID) {
    return axios.get(`api/v1/delivery/${deliveryID}`)
  },

  /**
   * Repeat a delivery by id
   * @param {String} deliveryID - the delivery id
   * @param {Object} additionalData - additional data to include in the request
   */
  repeatByID: async function (deliveryID, additionalData = {}) {
    return axios.post(`api/v1/delivery/${deliveryID}`, additionalData)
  }
}
